"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_lazy_load_image_component_1 = require("react-lazy-load-image-component");
const settlementQuery_1 = require("../../../../queries/settlementQuery");
const walletDetails_1 = require("../component/walletDetails");
const ViewReceiptImageModal = ({ open = false, onClose = () => ({}), receipt = {}, }) => {
    const { data } = (0, react_query_1.useQuery)((0, settlementQuery_1.viewReceiptImage)({ receiptId: receipt?.id || '' }));
    return ((0, jsx_runtime_1.jsx)(material_1.Modal, { open: open, onClose: onClose, "aria-labelledby": "modal-modal-title", style: { backgroundColor: 'white' }, "aria-describedby": "modal-modal-description", children: (0, jsx_runtime_1.jsxs)(walletDetails_1.ImageContainer, { "data-testid": "receipt-container", children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                        display: 'flex',
                        width: '100%',
                        minWidth: '100%',
                        marginBottom: 'auto',
                        backgroundColor: 'white',
                    }, children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { "aria-label": "close", onClick: onClose, style: { marginLeft: 'auto' }, children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }) }), data?.objectURL ? ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                        overflow: 'auto',
                        width: '100%',
                        height: '100%',
                    }, children: [data.type === 'image' && ((0, jsx_runtime_1.jsx)(react_lazy_load_image_component_1.LazyLoadImage, { alt: "receipt image", style: {
                                maxWidth: '100%',
                                maxHeight: '100%',
                                margin: '0 auto',
                                display: 'flex',
                            }, src: data.objectURL })), data.type === 'pdf' && ((0, jsx_runtime_1.jsx)("object", { style: {
                                maxWidth: '100%',
                                maxHeight: '100%',
                                margin: '0px auto',
                                display: 'flex',
                                width: '100%',
                                height: '100%',
                            }, data: data.objectURL, "aria-label": "pdf" }))] })) : null] }) }));
};
exports.default = ViewReceiptImageModal;
